export const types = {
    GET_AGENTS_REQUEST: 'GET_AGENTS_REQUEST',
    GET_AGENTS_SUCCESS: 'GET_AGENTS_SUCCESS',
    GET_AGENTS_FAILURE: 'GET_AGENTS_FAILURE',

    GET_AGENT_DETAILS_REQUEST: 'GET_AGENT_DETAILS_REQUEST',
    GET_AGENT_DETAILS_SUCCESS: 'GET_AGENT_DETAILS_SUCCESS',
    GET_AGENT_DETAILS_FAILURE: 'GET_AGENT_DETAILS_FAILURE',

    DELETE_AGENT_REQUEST: 'DELETE_AGENT_REQUEST',
    DELETE_AGENT_SUCCESS: 'DELETE_AGENT_SUCCESS',
    DELETE_AGENT_FAILURE: 'DELETE_AGENT_FAILURE',

    ADD_AGENT_REQUEST: 'ADD_AGENT_REQUEST',
    ADD_AGENT_SUCCESS: 'ADD_AGENT_SUCCESS',
    ADD_AGENT_FAILURE: 'ADD_AGENT_FAILURE',

    GET_PERSONA_TYPES_DETAILS: 'GET_PERSONA_TYPES_DETAILS'
}